import * as React from 'react';
import { ActivityIndicator, ActivityIndicatorProps } from 'react-native';
import theme from '../../util/theme';

export default (props: ActivityIndicatorProps) => (
  <ActivityIndicator size="large" color={theme.palette.primary} {...props} />
);
